'use strict';

angular.module('atex.art').controller('ArtContentPreviewCtrl',
  ['$scope', '$q', '$timeout', '$rootScope', '$location', 'ArtNotificationService', 'Application', 'ContentService', 'PreviewService',
    'article', 'user', 'CopyfitUtils', 'ArtPreviewService', 'ClipboardService', 'valdr', 'valdrEvents', 'PageTitle', 'ArtCommonServices', '$translate',
    'ArtPrintData', '$window', '$route', 'ApplicationConfigurationService',
    function ($scope, $q, $timeout, $rootScope, $location, ArtNotificationService, Application, ContentService, PreviewService,
              article, user, CopyfitUtils, ArtPreviewService, ClipboardService, valdrProvider, valdrEvents, PageTitle, ArtCommonServices, $translate,
              ArtPrintData, $window, $route, ApplicationConfigurationService) {

      // "printSyncingCounter" holds a count of operation undergoing on print system (i.e
      // . print lock)
      // in order to disable the save during those operations. See for example "lockAspect" into copyfit-element-channel.js
      var printSyncingCounter = 0;
      $scope.$on("atex:incrementPrintSyncingCounter", function() {
        printSyncingCounter++;
        $scope.printSyncing = printSyncingCounter > 0;
      });
      $scope.$on("atex:decrementPrintSyncingCounter", function() {
        printSyncingCounter--;
        $scope.printSyncing = printSyncingCounter > 0;
      });

      var copyfitUtils = CopyfitUtils();

      $scope.locale = $translate.use();

      if ($rootScope.editChain) {
        $rootScope.editChain.add(article);
      }

      $scope.hasChain = function () {
        return !!($rootScope.editChain && $rootScope.editChain.size() > 1);
      };

      $scope.getWindowTitle = function (content) {
        if (typeof content.template === 'undefined' || typeof content.template.namePath === 'undefined') {
          return '?';
        }

        var path = JSON.parse(JSON.stringify(content.template.namePath || ["name"]));
        var pathArray = atex.onecms.ObjectUtils.expandShortPath(path);
        var name = atex.onecms.ObjectUtils.getByPath(content.data.aspects, pathArray);

        if (name === undefined || name === "") {
          return 'new';
        }

        return name.trim();
      };

      var readAssociatedSites = function(associatedSiteIds) {
        var promises = (associatedSiteIds || []).map(function(associatedSiteId) {
          return ContentService.getContent({ id: associatedSiteId }).then(function(responseInfo) {
            var siteName = atex.onecms.ObjectUtils.getByPath(responseInfo, 'data/aspects/contentData/data/name') || washContentId(associatedSiteId);

            return {
              id: washContentId(associatedSiteId),
              name: siteName
            };
          });
        });

        return $q.all(promises).then(function(results) {
          $scope.webPreviewPossibleContexts = results;
        }).then(undefined, function(error) {
          console.warn('Failed to read associated sites from server!', error);
        });
      };

      $scope.articleLoaded = false;
      $scope.article = article;

      $scope.isArticleLocked = false;
      var readConfig = function() {
        return ApplicationConfigurationService.getConfigurationFor(['previewView', 'disableEdit']).then(function(data) {
          if (data) {
            $scope.isArticleLocked = article.locked;
          }
        });
      };
      readConfig();

      $scope.copyfitActive = false;

      $rootScope.PageTitle = PageTitle;
      PageTitle.setTitle($scope.getWindowTitle(article));

      $scope.copyEnabled = atex.onecms.OneCMSUtils.isNewContentId(article.meta.id) && article.meta.id.indexOf('draft:') === -1;
      $scope.webPreviewEnabled = (atex.onecms.ObjectUtils.getByPath(article.template, 'webPreviewEnabled') === true);
      $scope.printPreviewDisabled = (atex.onecms.ObjectUtils.getByPath(article.template, 'printPreviewDisabled') === true);

      $scope.articleLoaded = true;

      _.extend($scope, atex.act.ViewUtils);

      var washContentId = function(id) {
        var washedId = id.replace(/contentid\//ig, '').replace(/externalid\//ig, '');
        return (washedId.indexOf('policy:') === -1) ? 'policy:' + washedId : washedId;
      };

      $scope.prepareEdit = function (topDomainObject) {
        $scope.topDomainObject = topDomainObject;
        if (typeof $rootScope.editChain !== 'undefined') {
          $scope.editChainEventHandler = $scope.topDomainObject.on('act:resource-remove', function (event, resourceId) {
            $rootScope.editChain.sliceFrom(resourceId);
          });
        }
        var editionId = $route.current.params.edition || "0";
        var fetchOptions = {
          topDomainObject: topDomainObject,
          newArticle: false,
          actReloaded: false,
          lock: false,
          rootScope: $rootScope,
          edition: editionId
        };
        var associatedSitesDomainObject = atex.onecms.DomainObjectUtils.getDomainObjectByPath(topDomainObject, 'aspects/p.InsertionInfo/data/associatedSites');
        var printDataPromise = $q.when(ArtPrintData.fetchPrintData(fetchOptions));
        if ($scope.webPreviewEnabled === true && typeof associatedSitesDomainObject !== 'undefined') {
          return readAssociatedSites(associatedSitesDomainObject.getAll()).then(function () {
            return printDataPromise;
          });
        }
        return printDataPromise;
      };

      $scope.doWebPreview = function(specificContext) {
        if ($scope.webPreviewEnabled === false) {
          console.warn('Web preview called for a type without support, ignoring request...');
          return;
        }

        delete $scope.webPreviewErrorMessage;

        var contextCalculationPromise = (typeof $scope.webPreviewContexts === 'undefined')
          ? ArtPreviewService.calculatePreviewContext($scope.topDomainObject) : $q.when($scope.webPreviewContexts);

        $scope.webPreviewInProgress = true;

        contextCalculationPromise.then(function(context) {
          $scope.webPreviewContexts = context;

          var data = {
            previewContexts: (typeof specificContext !== 'undefined') ? [specificContext] : $scope.webPreviewContexts
          };

          return ArtPreviewService.preparePreview('web', $scope.article, data, $scope.topDomainObject);
        }).then(function(previewResult) {
          ArtPreviewService.openPreview(previewResult, $scope.article.meta.id);
        }).then(undefined, function(error) {
          console.log('Error while generating web preview!', error);

          var errorMessage;
          if (typeof error.rootCause !== 'undefined' && typeof error.rootCause.response !== 'undefined' && typeof error.rootCause.response.message !== 'undefined') {
            errorMessage = (typeof error !== 'undefined' && typeof error.cause !== 'undefined')
              ? 'Error while generating web preview. ' + error.cause + ': ' + error.rootCause.response.message
              : 'Error while generating web preview: ' + error.rootCause.response.message;
          } else {
            errorMessage = (typeof error !== 'undefined' && typeof error.cause !== 'undefined')
              ? 'Error while generating web preview: ' + error.cause
              : 'Error while generating web preview.';
          }

          $scope.webPreviewErrorMessage = errorMessage;
        }).then(function() {
          $scope.webPreviewInProgress = false;
        });
      };

      $scope.doCopyToClipboard = _.debounce( function() {
        var clipboardInfo = {
          data: [
            {
              id: 'contentid/' + $scope.article.meta.id,
              type: $scope.article.template.type
            }
          ]
        };

        ClipboardService.putInClipboard(clipboardInfo).then(function () {

          var notification = atex.act.Notification({
            type: 'success',
            persistent: false,
            message: 'The item has been copied to the clipboard.'
          });
          $scope.clipboardNotificationToast = ArtNotificationService.addNotification(notification, false, function () {
          });

        }, function (error) {

          var notification = atex.act.Notification({
            type: 'error',
            persistent: false,
            message: 'Failed to copy the item to the clipboard.'
          });
          $scope.clipboardNotificationToast = ArtNotificationService.addNotification(notification, false, function () {
          });
        });
      }, 500, true);

      $scope.$on('$locationChangeStart', function(event, next, current) {
        if($scope.hasChain()) {
          if(!$rootScope.editChain.getPrevious()) {
            $rootScope.editChain.clear();
          }
        }
      });

      // Unload Handling
      var unlockOnUnload = false;

      var shouldUnlockPrintElements = function() {
        return ArtPrintData.hasLockedElements( $scope.article );
      };


      var shouldSavePrintData = function() {
        return ArtPrintData.hasPrintChangedElements( $scope.article );
      };

      var onUnloadPromptFn = function() {
        unlockOnUnload = shouldUnlockPrintElements();
        if ( $scope.copyfitActive && shouldSavePrintData() && unlockOnUnload) {
          console.log("This action will discard your changes. 1");
          return "This action will discard your changes.";
        }
      };

      var onUnloadFn = function() {
        if (unlockOnUnload) {
          ArtPrintData.sendPrintData({
            article: $scope.article,
            save: false,
            unlock: true,
            rootScope: $rootScope,
            topDomainObject: $scope.topDomainObject,
            unload: true
          });
          $rootScope.$digest();
        }
      };
      $window.onbeforeunload = onUnloadPromptFn;
      $window.onunload = onUnloadFn;
      // END Unload Handling

      function toggleIntent(template, intent) {
        if ( typeof template.layout === 'undefined' ) {
          // not using views.
          for (var index in template.dataBindings) {
            var templateFieldElement = copyfitUtils.findTemplateFieldByFieldIndex( index );

            if (typeof templateFieldElement !== 'undefined') {
              var dataBinding = template.dataBindings[index];
              var hasIntent = intent;

              if (typeof dataBinding !== 'undefined' && typeof dataBinding.config !== 'undefined') {
                hasIntent = copyfitUtils.getIntent(dataBinding.config.intents, intent);
              }

              copyfitUtils.displayControl(templateFieldElement, hasIntent);
            }
          }
          return;
        }

        var templateViewElements = $('.tab-pane[x-act-view],.tab-pill[x-act-view]');

        /* jshint -W004 */
        for (var index = 0; index < templateViewElements.length; index++ ) {
          var viewElement = templateViewElements[index];
          var view = template.layout.views[$(viewElement).attr('x-act-view')];

          copyfitUtils.displayControl(viewElement, copyfitUtils.getIntent(view.intents, intent));

          for (var fieldIndex in view.fields) {

            var dataBinding = _.find(template.dataBindings, function(binding) {
              return view.fields[fieldIndex] === binding.name;
            });

            var hasIntent = intent;

            if (typeof dataBinding === 'undefined') {
              console.warn("No data binding using the name '" + view.fields[fieldIndex] + "' could be found, skipping...");
            }

            if (typeof dataBinding !== 'undefined' && typeof dataBinding.config !== 'undefined') {
              hasIntent = copyfitUtils.getIntent(dataBinding.config.intents, intent);
            }

            var templateFieldElement = copyfitUtils.findTemplateFieldByView(view.name, fieldIndex);

            if (typeof templateFieldElement !== 'undefined') {
              copyfitUtils.displayControl(templateFieldElement, hasIntent);
            }
          }
        }
        /* jshint +W004 */
      }

      $scope.$on('copyfit:previewControl', function(event, operation, copyfit ) {
        if (operation === "settings") {
          if ( typeof copyfit !== 'undefined' ) {
            $scope.copyfit = copyfit;
            $scope.copyfitActive = true;
            toggleIntent( $scope.article.template, $scope.copyfit.toggleIntent.text() );
          }
        } else if (operation === "toggleIntentChanged") {
          toggleIntent( $scope.article.template, $scope.copyfit.toggleIntent.text() );
        }
      });

      $scope.$on('copyfit:printServerOffline', function(event, offline) {
        setOffline(offline);
      });

      $scope.$on('copyfit:printOfflineAcknowledged', function(event, acknowledged) {
        $rootScope.printOfflineAcknowledged = acknowledged;
      });

      var setOffline = function(offline) {
        if ($rootScope.printOffline !== offline) {
          $rootScope.printOffline = offline;

          if (!offline) {
            $rootScope.$broadcast('copyfit:printOfflineAcknowledged', false);
          }
        }
      };

      $scope.isOffline = function() {
        return $rootScope.printOffline;
      };

      var setActiveCmd = function() {
        if ( shouldSavePrintData() ) {
          $scope.activeCmd = $scope.saveCmd;
        } else {
          $scope.activeCmd = $scope.closeCmd;
        }
      };

      var saveAndClose = function() {
        $scope.saving = true;
        if ( shouldSavePrintData() ) {
          return ArtPrintData.sendPrintData({
            article: $scope.article,
            save: true,
            unlock: true,
            rootScope: $rootScope,
            topDomainObject: $scope.topDomainObject
          }).then(function() {
            ArtCommonServices.close();
          }).finally(function() {
            $scope.saving = false;
          });
        }
      };

      var save = function() {
        $scope.saving = true;
        if ( shouldSavePrintData() ) {
          return ArtPrintData.sendPrintData({
            article: $scope.article,
            save: true,
            unlock: false,
            rootScope: $rootScope,
            topDomainObject: $scope.topDomainObject
          }).finally(function() {
            setActiveCmd();
            $scope.saving = false;
          });
        }
      };

      function doClose() {
        if ($scope.hasChain() && $rootScope.editChain.hasPrevious()) {
          $rootScope.editChain.goToPrevious();
        } else {
          $timeout(function () {
            ArtCommonServices.close();
            $scope.closing = false;
          }, 500);
        }
      }

      var close = function() {
        if (shouldUnlockPrintElements()) {
          ArtPrintData.sendPrintData({
            article: $scope.article,
            save: false,
            unlock: true,
            onComplete: function() {
              doClose();
            },
            rootScope: $rootScope,
            topDomainObject: $scope.topDomainObject
          });
        } else {
          doClose();
        }
      };

      var discardAndClose = function() {
        if ( shouldUnlockPrintElements() ) {
          ArtPrintData.sendPrintData({
            article: $scope.article,
            save: false,
            unlock: true,
            onComplete: function () {
              doClose();
            },
            rootScope: $rootScope,
            topDomainObject: $scope.topDomainObject
          });
        } else {
          doClose();
        }
      };

      var createCmd = function (cmd) {
        return {
          name: cmd.name || "act.unknown.cmd",
          label: cmd.label || cmd.name,
          tooltip: cmd.tooltip || cmd.label,
          icon: cmd.icon || "",
          isEnabled: cmd.isEnabled || function () {
            return true;
          },
          isVisible: cmd.isVisible || function () {
            return true;
          },
          doCmd: cmd.doCmd || function () {
            return true;
          }
        };
      };

      $scope.close = createCmd({
        name: 'act.cmd.close.preview',
        label: $translate.getTranslationTable().CLOSE,
        tooltip:$translate.getTranslationTable().CLOSE,
        icon: 'fa fa-times',
        isEnabled: function() {
          return true;
        },
        doCmd:  function() {
          ArtCommonServices.close();
        }
      });

      $scope.edit = createCmd({
        name: 'act.cmd.edit.preview',
        label: $translate.getTranslationTable().EDIT_CONTENT,
        tooltip: $translate.getTranslationTable().EDIT_CONTENT,
        icon: 'fa fa-pencil',
        isEnabled: function() {
          return !shouldSavePrintData();
        },
        doCmd:  function() {
          $location.path("/edit/" + article.meta.id);
        }
      });

      $scope.closeCmd = createCmd({
        name: 'act.cmd.close.preview',
        label: $translate.getTranslationTable().CLOSE,
        tooltip:$translate.getTranslationTable().CLOSE,
        icon: 'fa fa-times',
        isEnabled: function() {
          return !shouldSavePrintData();
        },
        doCmd:  function() {
          close();
        }
      });

      $scope.saveAndCloseCmd = createCmd({
        name: 'act.cmd.save.close',
        label: 'Save and close',
        tooltip: 'Save and close',
        icon: 'fa-floppy-o',
        isEnabled: function() {
          return !$scope.printSyncing && shouldSavePrintData();
        },
        doCmd: saveAndClose
      });

      $scope.saveCmd = createCmd({
        name: 'act.cmd.save',
        label: 'Save',
        tooltip: 'Save',
        icon: 'fa-floppy-o',
        isEnabled: function() {
          return !$scope.printSyncing && shouldSavePrintData();
        },
        doCmd: save
      });

      $scope.discardAndCloseCmd = createCmd({
        name: 'act.cmd.discard.close',
        label: 'Discard and close',
        tooltip: 'Discard and close',
        icon: 'fa-remove',
        isEnabled: function() {
          return $scope.hasChain() === false;
        },
        isVisible: function() {
          return $scope.hasChain() === false;
        },
        doCmd: function() {
          discardAndClose();
        }
      });

      $scope.activeCmd = $scope.closeCmd;

      $translate(['SAVE', 'CLOSE', 'SAVE_AND_CLOSE', 'DISCARD_AND_CLOSE']).then(function (translations) {
        $scope.saveCmd.label = translations.SAVE;
        $scope.saveCmd.tooltip = translations.SAVE;
        $scope.closeCmd.label = translations.CLOSE;
        $scope.closeCmd.tooltip = translations.CLOSE;
        $scope.saveAndCloseCmd.label = translations.SAVE_AND_CLOSE;
        $scope.saveAndCloseCmd.tooltip = translations.SAVE_AND_CLOSE;
        $scope.discardAndCloseCmd.label = translations.DISCARD_AND_CLOSE;
        $scope.discardAndCloseCmd.tooltip = translations.DISCARD_AND_CLOSE;
      });

      $scope.changeStartCallback = function() {
      };

      $scope.changeEndCallback = function(data) {
        // Here we always set local.persisted = false in order to mark the current article as modified
        // and send down the new content into storeToWorkspace (for the OLD way of getting preview)
        $scope.article.local.persisted = false;
        $scope.article.data.aspects = data.aspects;
        setActiveCmd();
      };

      $scope.initCallback = function () {
        $scope.isContentEditorLoading = true;
      };

      $scope.loadCallback = function () {
        $scope.isContentEditorLoading = false;
        $scope.article.local.valid = $scope.myForm.$valid;
        var printVariantsDomainObject = atex.onecms.DomainObjectUtils.getDomainObjectByPath($scope.topDomainObject, 'aspects/atex.PrintVariants/data');
        if (typeof printVariantsDomainObject !== 'undefined') {
        	// Align atex.PrintVariants in the scope article with the fetchPrintData result
          if ($scope.article.data.aspects['atex.PrintVariants']) {
            $scope.article.data.aspects['atex.PrintVariants'].data = printVariantsDomainObject.getData();
          } else {
            $scope.article.data.aspects['atex.PrintVariants'] = {
              data: angular.copy(printVariantsDomainObject.getData())
            };
          }
        }
      };

      $scope.error = function (error) {
        Application.currentErrorInfo = {error: error};
        $location.path("/error");
      };
    }
  ]);

var ArticlePreviewController = {
  resolves: {
    'preload-factory' : function(PreloadService) {
      return PreloadService.preloadFactoryList('actList');
    },
    'article': function ($route, $q, $location, $rootScope, Application, ArtSynchronizationService, ArtContentStore, ArtTemplateStore, ArtLockingService, ArtCommonServices, $translate) {
      var _article = null;
      return ArtSynchronizationService.whenSynchronized({
        ids: [ $route.current.params.id ]
      }).then(function () {
        return ArtContentStore.getById($route.current.params.id).then(function (article) {
          _article = article;

          return ArtTemplateStore.getAll().then(function (templates) {
            var template = _.find(templates, function(template) {
              return typeof template.type !== 'undefined' && template.type === article.data.aspects.contentData.data._type && ( template.id.endsWith('.preview') || template.id.endsWith('.readonly') );
            });

            if(!template) {
              template = ArtCommonServices.getTemplateFor(article, templates);
            }
            return template;
          });
        }).then(function (template) {

          if(!template) {
            Application.currentErrorInfo =  {
              error: {
                origin: "Contributor Tool Preview Controller",
                severity: atex.onecms.error.severities.CRITICAL,
                cause: "Missing template. Template not found for " + $route.current.params.id
              }
            };
            $location.path("/error");
          }
          _article.template = template;

          return ArtLockingService.isLocked(_article.meta.id).then(function (info) {
            _article.locked = false;

            if(info) {
              _article.locked = true;
              ArtLockingService.getUserNameById(info.lockedBy).then(function(username) {
                _article.message = $translate.getTranslationTable().CONTENT_LOCKED_MSG + " ("+ username +
                  " " + info.app + " " + moment(info.timestamp).locale($translate.use()).format('LLLL') +")";
              });
            }

            return _article;
          });
        });
      });
    },

    'user': function (ArtUserDataStore, AuthenticationService) {
      return AuthenticationService.getCurrentUser().then(function (currentUser) {
        return ArtUserDataStore.getById(currentUser.userId);
      });
    },

    'templates': function (ArtTemplateStore) {
      return ArtTemplateStore.getAll();
    }
  }
};
